import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Container,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem,
  UncontrolledDropdown,
} from 'reactstrap';

import { UPSTREAM_EMAIL_ADDRESS } from 'upstream-shared/constants';
import { UpstreamToken } from 'upstream-shared/models';

import { paths } from '../paths';
import { StylesDictionary } from '../theme';
import MainMenuAdmin from './MainMenuAdmin';
import Breadcrumbs from './App/Breadcrumbs';

interface HeaderProps {
  authUser?: UpstreamToken;
}

const DropdownItemLink = (props: { title?: string; to: string; children?: React.ReactNode }) => {
  return <DropdownItem tag={Link} {...props} />;
};

// const styles: StylesDictionary = {
//   upstream: {
//     fontSize: '1.4rem',
//     color: 'white',
//     textTransform: 'uppercase',
//     marginTop: '10px',
//   },
//   brand: {
//     height: '30px',
//     width: '268px',
//     marginTop: '-12px',
//     marginBottom: '-10px', // media query removes this under lg.
//   },
// };

const HeaderAdmin = (props: HeaderProps) => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const { authUser } = props;

  const getDisplayName = () => {
    const name = (authUser && authUser.email) || 'user@example.com';
    return name.substring(0, name.indexOf('@'));
  };

  return (
    <div className={'contentPageHeader'}>
      <Navbar style={{ backgroundColor: '#000' }} light={false} dark={true} expand={'md'}>
        <Container id={'header-container'} fluid>
          <Link to="/" className={'logo'}>
            <picture>
              <source media="(min-width:650px)" srcSet="/CARA_logo-desk_reverse.png" />
              <source media="(min-width:465px)" srcSet="/CARA_logo-desk_reverse.png" />
              <img src="/CARA_logo-desk_reverse.png" alt="CARA logo" />
            </picture>
          </Link>
          <NavbarToggler onClick={() => setIsOpen(!isOpen)} style={{ zIndex: 1000 }} />

          <Collapse isOpen={isOpen} navbar>
            <Nav navbar className={'ml-auto'}>
              {!authUser && pathname !== paths.LOGIN && (
                <NavItem>
                  <Link title={'Go to page to request a login email'} className={'btn btn-secondary'} to={paths.LOGIN}>
                    Login
                  </Link>
                </NavItem>
              )}
              {authUser && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret style={{ color: 'white' }}>
                    {getDisplayName()}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem disabled>{(authUser && authUser.email) || 'user@example.com'}</DropdownItem>
                    <DropdownItem divider />
                    <a href={`mailto:${UPSTREAM_EMAIL_ADDRESS}`} className="dropdown-item">
                      Contact Support
                    </a>
                    <DropdownItem divider />
                    <DropdownItemLink to={paths.LOGOUT}>Logout</DropdownItemLink>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <MainMenuAdmin />
      <Breadcrumbs />
    </div>
  );
};

export default HeaderAdmin;
